import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DEFAULT_ARTICLE_CLUSTERING_ENABLED } from '@/core/constants/preferences';

import { getUser } from '@/features/Auth/store';

import { updateArticleClusteringPreference } from './actions';

export type UserPreferencesState = {
  articleClusteringEnabled: boolean;
  isArticleClusteringPreferenceLoaded: boolean;
  isArticleClusteringUpdating: boolean;
  /** Bumped after preference is saved on the server so report lists refetch. */
  reportsPreferenceVersion: number;
};

const initialState: UserPreferencesState = {
  articleClusteringEnabled: DEFAULT_ARTICLE_CLUSTERING_ENABLED,
  isArticleClusteringPreferenceLoaded: true,
  isArticleClusteringUpdating: false,
  reportsPreferenceVersion: 0,
};

const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setArticleClusteringEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.articleClusteringEnabled = payload;
    },
    setArticleClusteringPreferenceLoaded: (state, { payload }: PayloadAction<boolean>) => {
      state.isArticleClusteringPreferenceLoaded = payload;
    },
    incrementReportsPreferenceVersion: state => {
      state.reportsPreferenceVersion += 1;
    },
  },
  extraReducers: builder =>
    builder
      .addCase(getUser.fulfilled, (state, { payload }) => {
        if (typeof payload.articleClusteringEnabled === 'boolean') {
          state.articleClusteringEnabled = payload.articleClusteringEnabled;
          state.isArticleClusteringPreferenceLoaded = true;
        }
      })
      .addCase(updateArticleClusteringPreference.pending, state => {
        state.isArticleClusteringUpdating = true;
      })
      .addCase(updateArticleClusteringPreference.fulfilled, state => {
        state.isArticleClusteringUpdating = false;
      })
      .addCase(updateArticleClusteringPreference.rejected, state => {
        state.isArticleClusteringUpdating = false;
      }),
});

export const {
  setArticleClusteringEnabled,
  setArticleClusteringPreferenceLoaded,
  incrementReportsPreferenceVersion,
} = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer;
